import { render } from "./StorageManufacturerList.vue?vue&type=template&id=ba29d336&scoped=true"
import script from "./StorageManufacturerList.vue?vue&type=script&lang=js"
export * from "./StorageManufacturerList.vue?vue&type=script&lang=js"

import "./StorageManufacturerList.vue?vue&type=style&index=0&id=ba29d336&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba29d336"]])

export default __exports__